<template>
  <div>
    <v-autocomplete
        :items="items"
        :loading="loading"
        :item-text="(item) => item.Name"
        :item-value="(item) => item.Id"
        v-bind="$attrs"
        v-on="$listeners"
        v-model="value"
        :hide-details="$attrs['hide-details'] === 'false' ? false : 'auto'"
        :outlined="$attrs['outlined'] === 'false' ? false : true"
        :clearable="$attrs['clearable'] === 'false' ? false : true"
        :dense="$attrs['dense'] === 'false' ? false : true"
        :label="$attrs['label'] ? $attrs['label'] : 'Ders Branşı'"
        ref="autocomplete"
        :filter="filterTR"
    >
      <template v-if="'multiple' in $attrs" v-slot:prepend-item>
        <div class="mx-4">
          <v-btn text small block @click="selectAll()"> Tümünü Seç</v-btn>
        </div>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip small v-if="index < 2">
          <span>{{ item.Name }}</span>
        </v-chip>
        <span v-if="index === 2" class="grey--text text-caption">
          (+{{ value.length - 2 }} seçili)
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service.js'

export default {
  name: 'core-lesson-branch',
  props: ['value', 'classLevelIds', 'classLevelId','examIds'],
  data() {
    return {items: [], loading: false}
  },
  components: {},
  mounted: function () {
    this.getDataFromApi()
  },
  watch: {
    classLevelIds() {
      this.getDataFromApi()
    },
    classLevelId() {
      this.getDataFromApi()
    },
    examIds() {
      this.getDataFromApi()
    }
  },
  methods: {
    selectAll() {
      this.$emit('input', this.items.map((s) => s.Id))
      this.$refs.autocomplete.blur()
    },
    getDataFromApi() {
      this.loading = true
      ApiService.setHeader()
      ApiService.post('api/LessonBranch', {
        sortBy: ['Name'],
        descending: [false],
        rowsPerPage: -1,
        page: 1,
        query: {
          ClassLevelIds: this.classLevelIds,
          ClassLevelId: this.classLevelId,
          ExamIds: this.examIds
        }
      }).then((data) => {
        this.items = data.data.Results
        this.loading = false
      }).catch(({response}) => {
        ApiService.showError(response)
        this.loading = false
      })
    }
  }
}
</script>
